export const disableLinksInInactiveSlides = (flickityObj) => {
  if (flickityObj) {
    $(flickityObj.slider).find('[aria-hidden="true"] a[href]').attr('tabindex', '-1');
  }
};

export const enableLinksInsideActiveSlides = (flickityObj) => {
  if (flickityObj) {
    $(flickityObj.selectedElement).find('a[href]').removeAttr('tabindex');
  }
};
